var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilkysmooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5125 3.62778C58.1496 6.35481 55.6826 10.1621 54.0005 15.3433C54.0005 15.3433 52.275 10.3788 55.421 5.46885C52.4611 8.14459 48.6989 12.6774 46.3989 19.7606C46.3989 19.7606 44.2833 13.6307 49.0793 8.25518C48.988 8.30175 48.8965 8.34669 48.8064 8.39326C40.826 12.4605 35.6512 20.56 35.3268 29.5098C35.3268 29.5162 35.3268 29.5242 35.3268 29.5308C35.3268 29.5308 31.6559 24.2997 34.6657 17.8793C34.6641 17.8809 34.6624 17.8826 34.6608 17.884C31.2579 20.8326 28.9016 24.7538 27.8809 29.1389C27.4153 31.1418 27.0942 33.3717 27.0062 35.8371C27.0062 35.8371 24.7078 32.5451 25.2451 27.9864C25.2423 27.9897 25.239 27.9928 25.2373 27.996C23.5069 30.3443 22.0208 32.6669 20.7607 34.9463C18.7592 38.5654 18.7463 42.9796 20.7351 46.607C20.7351 46.607 18.7463 45.6954 16.9485 43.5508C13.3739 54.3434 15.0082 63.3098 19.5184 67.8202C19.9595 68.2613 20.4651 68.6822 21.0094 69.0814C17.6548 79.6239 16.6081 89.6461 19.7572 100.924C23.5177 82.1484 24.6608 66.6402 47.1515 34.6459C40.7903 46.124 34.7474 59.2439 30.7938 72.3462C39.1437 72.7316 49.9008 68.083 58.9039 52.1653C69.305 33.7757 65.2312 13.2033 85.4362 1.90182C79.0095 0.171957 69.9874 0.730659 60.5125 3.62778Z",
    fill: "#F1B545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.218842 0.923828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilkysmooth);
export default __webpack_public_path__ + "static/media/silkysmooth.09463583f2f333e0214f56c39cc23015.svg";
export { ForwardRef as ReactComponent };